import { useTranslation } from 'react-i18next'
import React from 'react'

import { Title } from '../../../packages/kiti/components/presentation/Text'
import { useModalData } from '../../../components/modals/ModalsContext'
import { usePlaceTypeName } from '../../../utils/helpers/placeTypes'

const ModalHeader = _props => {
  const { t } = useTranslation('export')
  const entity = useModalData()
  const placeTypeName = usePlaceTypeName(entity, true)

  const entityName = placeTypeName ? placeTypeName : t('common:entity.' + entity)

  return (
    <Title size="h4" align="center" noMargin>
      {t('exportHistory')}
      {!!entity && ` ${t('of')} `}
      {entityName}
    </Title>
  )
}

export default ModalHeader
